import { Component } from "@angular/core";

@Component({
  selector: "top-menu-svg-sprite",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="bellIcon" viewBox="0 0 22 22" fill="none">
        <path
          d="M8.25 16.5C8.25 17.2293 8.53973 17.9288 9.05546 18.4445C9.57118 18.9603 10.2707 19.25 11 19.25C11.7293 19.25 12.4288 18.9603 12.9445 18.4445C13.4603 17.9288 13.75 17.2293 13.75 16.5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.81227 8.9375C4.81227 7.29647 5.46417 5.72266 6.62455 4.56228C7.78493 3.4019 9.35874 2.75 10.9998 2.75C12.6408 2.75 14.2146 3.4019 15.375 4.56228C16.5354 5.72266 17.1873 7.29647 17.1873 8.9375C17.1873 12.0158 17.9006 14.4891 18.4677 15.4688C18.528 15.5731 18.5597 15.6914 18.5598 15.8119C18.56 15.9324 18.5284 16.0508 18.4683 16.1552C18.4083 16.2596 18.3218 16.3465 18.2177 16.407C18.1135 16.4675 17.9952 16.4996 17.8748 16.5H4.12477C4.00444 16.4993 3.88641 16.467 3.78247 16.4063C3.67853 16.3457 3.59233 16.2589 3.53248 16.1545C3.47263 16.0501 3.44122 15.9318 3.44141 15.8115C3.44159 15.6911 3.47335 15.573 3.53352 15.4688C4.09985 14.4891 4.81227 12.0149 4.81227 8.9375Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="markAsReadIcon" viewBox="0 0 9 9" fill="none">
        <circle cx="4.5" cy="4.5" r="4.5" fill="#6B58B6" />
      </symbol>

      <symbol id="notifyMessageIcon" viewBox="0 0 7 8" fill="none">
        <path
          d="M6.34137 0.922852H0.528448C0.388295 0.922852 0.253882 0.978527 0.154779 1.07763C0.0556756 1.17673 0 1.31115 0 1.4513V5.67888C0 5.81904 0.0556756 5.95345 0.154779 6.05255C0.253882 6.15165 0.388295 6.20733 0.528448 6.20733H2.52433L2.97615 6.99802C3.02238 7.07888 3.08916 7.14608 3.16972 7.19282C3.25029 7.23956 3.34177 7.26418 3.43491 7.26418C3.52805 7.26418 3.61954 7.23956 3.7001 7.19282C3.78066 7.14608 3.84744 7.07888 3.89367 6.99802L4.34549 6.20733H6.34137C6.48153 6.20733 6.61594 6.15165 6.71504 6.05255C6.81415 5.95345 6.86982 5.81904 6.86982 5.67888V1.4513C6.86982 1.31115 6.81415 1.17673 6.71504 1.07763C6.61594 0.978527 6.48153 0.922852 6.34137 0.922852ZM1.98168 3.96143C1.90329 3.96143 1.82666 3.93818 1.76149 3.89463C1.69631 3.85108 1.64551 3.78918 1.61551 3.71676C1.58552 3.64434 1.57767 3.56465 1.59296 3.48777C1.60825 3.41089 1.646 3.34027 1.70143 3.28484C1.75686 3.22941 1.82748 3.19166 1.90436 3.17637C1.98124 3.16108 2.06093 3.16893 2.13335 3.19892C2.20577 3.22892 2.26767 3.27972 2.31122 3.3449C2.35477 3.41008 2.37802 3.4867 2.37802 3.56509C2.37802 3.67021 2.33626 3.77102 2.26193 3.84534C2.1876 3.91967 2.08679 3.96143 1.98168 3.96143ZM3.43491 3.96143C3.35652 3.96143 3.2799 3.93818 3.21472 3.89463C3.14954 3.85108 3.09874 3.78918 3.06874 3.71676C3.03875 3.64434 3.0309 3.56465 3.04619 3.48777C3.06148 3.41089 3.09923 3.34027 3.15466 3.28484C3.21009 3.22941 3.28071 3.19166 3.35759 3.17637C3.43447 3.16108 3.51416 3.16893 3.58658 3.19892C3.659 3.22892 3.7209 3.27972 3.76445 3.3449C3.808 3.41008 3.83125 3.4867 3.83125 3.56509C3.83125 3.67021 3.78949 3.77102 3.71516 3.84534C3.64084 3.91967 3.54003 3.96143 3.43491 3.96143ZM4.88814 3.96143C4.80975 3.96143 4.73313 3.93818 4.66795 3.89463C4.60277 3.85108 4.55197 3.78918 4.52198 3.71676C4.49198 3.64434 4.48413 3.56465 4.49942 3.48777C4.51472 3.41089 4.55246 3.34027 4.60789 3.28484C4.66332 3.22941 4.73394 3.19166 4.81082 3.17637C4.8877 3.16108 4.96739 3.16893 5.03981 3.19892C5.11223 3.22892 5.17413 3.27972 5.21768 3.3449C5.26123 3.41008 5.28448 3.4867 5.28448 3.56509C5.28448 3.67021 5.24272 3.77102 5.16839 3.84534C5.09407 3.91967 4.99326 3.96143 4.88814 3.96143Z"
          fill="white"
        />
      </symbol>

      <symbol id="notifyLoveIcon" viewBox="0 0 8 7" fill="none">
        <path
          d="M8 2.26095C8 4.81364 4.29321 6.87985 4.13536 6.96518C4.09375 6.98804 4.04724 7 4 7C3.95276 7 3.90625 6.98804 3.86464 6.96518C3.70679 6.87985 0 4.81364 0 2.26095C0.000661692 1.66152 0.234164 1.08683 0.64928 0.662963C1.0644 0.239099 1.62722 0.000675637 2.21429 0C2.95179 0 3.5975 0.323826 4 0.871195C4.4025 0.323826 5.04821 0 5.78571 0C6.37278 0.000675637 6.9356 0.239099 7.35072 0.662963C7.76584 1.08683 7.99934 1.66152 8 2.26095Z"
          fill="white"
        />
      </symbol>

      <symbol id="notifyShareIcon" viewBox="0 0 8 6" fill="none">
        <path
          d="M7.91621 3.05377L5.05914 5.66198C5.01918 5.69849 4.96825 5.72337 4.9128 5.73345C4.85735 5.74353 4.79987 5.73836 4.74763 5.71861C4.6954 5.69885 4.65076 5.66539 4.61937 5.62246C4.58798 5.57953 4.57125 5.52906 4.57129 5.47745V4.18084C2.53206 4.28647 1.13388 5.49375 0.741388 5.87618C0.679758 5.93626 0.598938 5.97707 0.51043 5.99279C0.421923 6.00852 0.330237 5.99836 0.248421 5.96376C0.166605 5.92916 0.0988281 5.87188 0.0547355 5.80008C0.0106428 5.72828 -0.00751875 5.64561 0.00283536 5.56384C0.135332 4.51208 0.766387 3.50042 1.77993 2.71535C2.6217 2.0633 3.64489 1.64957 4.57129 1.57719V0.261026C4.57125 0.209411 4.58798 0.158944 4.61937 0.116015C4.65076 0.073085 4.6954 0.0396233 4.74763 0.0198654C4.79987 0.000107587 4.85735 -0.00505787 4.9128 0.00502296C4.96825 0.0151038 5.01918 0.0399776 5.05914 0.0764955L7.91621 2.68471C7.94277 2.70893 7.96384 2.73769 7.97822 2.76936C7.9926 2.80102 8 2.83496 8 2.86924C8 2.90351 7.9926 2.93745 7.97822 2.96911C7.96384 3.00078 7.94277 3.02954 7.91621 3.05377Z"
          fill="white"
        />
      </symbol>

      <symbol id="upgradeIcon" viewBox="0 0 18 18" fill="none">
        <g clip-path="url(#clip0_2_1701)">
          <path
            d="M2.97426 8.4375C2.70699 8.4375 2.57314 8.11436 2.76213 7.92537L8.78787 1.89963C8.90503 1.78248 9.09497 1.78247 9.21213 1.89963L15.2379 7.92537C15.4269 8.11436 15.293 8.4375 15.0257 8.4375H12.675C12.5093 8.4375 12.375 8.57181 12.375 8.7375V10.3875C12.375 10.5532 12.2407 10.6875 12.075 10.6875H5.925C5.75932 10.6875 5.625 10.5532 5.625 10.3875V8.7375C5.625 8.57181 5.49069 8.4375 5.325 8.4375H2.97426Z"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.375 15.1875H5.625"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.375 12.9375H5.625"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2_1701">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="arrowDownWhite" viewBox="0 0 12 12" fill="none">
        <g clip-path="url(#clip0_522_24)">
          <path
            d="M9.75 4.5L6 8.25L2.25 4.5"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_522_24">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="logOutIcon" viewBox="0 0 21 21" fill="none">
        <path
          d="M13.6224 7.23755L16.9105 10.5257L13.6224 13.8139"
          stroke="var(--stroke-color,white)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.14209 10.5258H16.9105"
          stroke="var(--stroke-color,white)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.14212 17.4152H3.75791C3.5918 17.4152 3.43249 17.3492 3.31504 17.2317C3.19758 17.1143 3.13159 16.955 3.13159 16.7889V4.26255C3.13159 4.09644 3.19758 3.93713 3.31504 3.81967C3.43249 3.70222 3.5918 3.63623 3.75791 3.63623H8.14212"
          stroke="var(--stroke-color,white)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="loginIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_815_30)">
          <path
            d="M10 11.875C10.5178 11.875 10.9375 11.4553 10.9375 10.9375C10.9375 10.4197 10.5178 10 10 10C9.48223 10 9.0625 10.4197 9.0625 10.9375C9.0625 11.4553 9.48223 11.875 10 11.875Z"
            fill="white"
          />
          <path
            d="M16.25 6.25H13.4375V4.0625C13.4375 3.15082 13.0753 2.27648 12.4307 1.63182C11.786 0.987164 10.9117 0.625 10 0.625C9.08832 0.625 8.21398 0.987164 7.56932 1.63182C6.92466 2.27648 6.5625 3.15082 6.5625 4.0625V6.25H3.75C3.41848 6.25 3.10054 6.3817 2.86612 6.61612C2.6317 6.85054 2.5 7.16848 2.5 7.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V7.5C17.5 7.16848 17.3683 6.85054 17.1339 6.61612C16.8995 6.3817 16.5815 6.25 16.25 6.25ZM10.625 13.0312V14.375C10.625 14.5408 10.5592 14.6997 10.4419 14.8169C10.3247 14.9342 10.1658 15 10 15C9.83424 15 9.67527 14.9342 9.55806 14.8169C9.44085 14.6997 9.375 14.5408 9.375 14.375V13.0312C8.87146 12.8811 8.43878 12.5548 8.15608 12.1119C7.87339 11.6689 7.75956 11.1391 7.83542 10.6191C7.91127 10.0992 8.17175 9.62393 8.56921 9.28025C8.96667 8.93657 9.47456 8.74744 10 8.74744C10.5254 8.74744 11.0333 8.93657 11.4308 9.28025C11.8283 9.62393 12.0887 10.0992 12.1646 10.6191C12.2404 11.1391 12.1266 11.6689 11.8439 12.1119C11.5612 12.5548 11.1285 12.8811 10.625 13.0312ZM12.1875 6.25H7.8125V4.0625C7.8125 3.48234 8.04297 2.92594 8.4532 2.5157C8.86344 2.10547 9.41984 1.875 10 1.875C10.5802 1.875 11.1366 2.10547 11.5468 2.5157C11.957 2.92594 12.1875 3.48234 12.1875 4.0625V6.25Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_815_30">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="newPostIcon" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7.5" fill="#FA8027" stroke="white" />
        <g clip-path="url(#clip0_1795_171)">
          <path
            d="M11.75 8V11.125C11.75 11.2908 11.6842 11.4497 11.5669 11.5669C11.4497 11.6842 11.2908 11.75 11.125 11.75H4.875C4.70924 11.75 4.55027 11.6842 4.43306 11.5669C4.31585 11.4497 4.25 11.2908 4.25 11.125V4.875C4.25 4.70924 4.31585 4.55027 4.43306 4.43306C4.55027 4.31585 4.70924 4.25 4.875 4.25H8C8.08288 4.25 8.16237 4.28293 8.22097 4.34153C8.27958 4.40014 8.3125 4.47962 8.3125 4.5625C8.3125 4.64538 8.27958 4.72487 8.22097 4.78347C8.16237 4.84208 8.08288 4.875 8 4.875H4.875V11.125H11.125V8C11.125 7.91712 11.1579 7.83764 11.2165 7.77903C11.2751 7.72043 11.3546 7.6875 11.4375 7.6875C11.5204 7.6875 11.5999 7.72043 11.6585 7.77903C11.7171 7.83764 11.75 7.91712 11.75 8ZM11.9711 5.7211L8.22109 9.4711C8.19205 9.50011 8.15758 9.52311 8.11964 9.53879C8.0817 9.55448 8.04105 9.56253 8 9.5625H6.75C6.66712 9.5625 6.58763 9.52958 6.52903 9.47097C6.47042 9.41237 6.4375 9.33288 6.4375 9.25V8C6.43747 7.95895 6.44552 7.9183 6.46121 7.88036C6.47689 7.84243 6.4999 7.80795 6.52891 7.77891L10.2789 4.02891C10.3079 3.99985 10.3424 3.9768 10.3803 3.96108C10.4183 3.94535 10.4589 3.93726 10.5 3.93726C10.5411 3.93726 10.5817 3.94535 10.6197 3.96108C10.6576 3.9768 10.6921 3.99985 10.7211 4.02891L11.9711 5.27891C12.0001 5.30793 12.0232 5.3424 12.0389 5.38033C12.0547 5.41827 12.0627 5.45893 12.0627 5.5C12.0627 5.54107 12.0547 5.58173 12.0389 5.61967C12.0232 5.65761 12.0001 5.69207 11.9711 5.7211ZM11.307 5.5L10.5 4.6918L10.0043 5.1875L10.8125 5.9957L11.307 5.5Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1795_171">
            <rect
              width="10"
              height="10"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="topMenuMagicWandIcon" viewBox="0 0 17 17" fill="none">
        <path
          d="M14.1549 5.58129H13.8788C13.8788 4.30317 12.8426 3.26699 11.5645 3.26699V2.99082C12.8426 2.99082 13.8788 1.95463 13.8788 0.676514H14.1549C14.1549 1.95463 15.1911 2.99082 16.4692 2.99082V3.26699C15.1911 3.26699 14.1549 4.30317 14.1549 5.58129Z"
          fill="white"
        />
        <path
          d="M3.45691 16.0673H3.09504C3.09504 14.3926 1.73728 13.0348 0.0625 13.0348V12.6729C1.73728 12.6729 3.09504 11.3152 3.09504 9.64038H3.45691C3.45691 11.3152 4.81468 12.6729 6.48945 12.6729V13.0348C4.81468 13.0348 3.45691 14.3926 3.45691 16.0673Z"
          fill="white"
        />
        <path
          d="M8.41659 2.36782H8.28327C8.28327 1.7508 7.78304 1.25057 7.16602 1.25057V1.11725C7.78304 1.11725 8.28327 0.617023 8.28327 0H8.41659C8.41659 0.617023 8.91682 1.11725 9.53384 1.11725V1.25057C8.91682 1.25057 8.41659 1.7508 8.41659 2.36782Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.38824 1.39643C0.621535 2.16313 0.621533 3.4062 1.38823 4.1729L12.8353 15.62C13.602 16.3867 14.8451 16.3867 15.6118 15.62C16.3785 14.8533 16.3785 13.6102 15.6118 12.8435L4.16471 1.39643C3.39801 0.62973 2.15494 0.629731 1.38824 1.39643ZM2.09902 2.10777C1.68082 2.52597 1.68081 3.20401 2.09902 3.62221L7.21031 8.7335C7.62851 9.1517 8.30655 9.1517 8.72475 8.7335C9.14295 8.3153 9.14295 7.63727 8.72475 7.21907L3.61346 2.10777C3.19525 1.68957 2.51722 1.68957 2.09902 2.10777Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.707107 2.07756C0.316582 2.46809 0.316582 3.10125 0.707106 3.49177L13.5164 16.3011C13.9069 16.6916 14.5401 16.6916 14.9306 16.3011L16.2929 14.9388C16.6834 14.5483 16.6834 13.9151 16.2929 13.5246L3.48358 0.715303C3.09305 0.324779 2.45989 0.324779 2.06936 0.715303L0.707107 2.07756ZM2.85624 1.35055L1.3418 2.86499L8.00598 9.52918L9.52042 8.01474L2.85624 1.35055Z"
          fill="white"
        />
      </symbol>
    </svg>
  `,
})
export class TopMenuSvgSpriteComponent {}
